import { Culture } from '../../types';

export const tohonoOodham: Culture = {
  name: 'Tohono O\'odham',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Baboquivari',
      phonetic: 'bah-boh-kee-vah-ree',
      description: 'Sacred mountain of the Tohono O\'odham.'
    },
    {
      word: 'Ha:san',
      phonetic: 'hah-sahn',
      description: 'O\'odham word for "saguaro cactus."'
    },
    {
      word: 'Jiosh',
      phonetic: 'hee-ohsh',
      description: 'O\'odham word for "god" or "creator."'
    },
    {
      word: 'O\'odham',
      phonetic: 'awe-awe-thahm',
      description: 'Means "The People" in the O\'odham language.'
    },
    {
      word: 'We:weli',
      phonetic: 'way-way-lee',
      description: 'O\'odham word meaning "butterfly."'
    }
  ]
};